import {
  Button,
  Space,
  Image as AntImage
} from "antd";
import styled from "styled-components";
import { WarningFilled, QuestionFilled, IMG_QR } from "@assets";

export const MainContainer = styled.div`
position: relative;
min-height: 100vh;
`;
export const RootContainer = styled.div`
  padding: 16px;

  .ant-collapse {
    background-color: #fff;
    border: 1px solid #e1cce0;

    .ant-image {
      margin-bottom: 12px;
    }
  }

  .ant-collapse-header {
    flex-direction: row-reverse;
  }

  .ant-collapse-header-text {
    font-size: 14px;
    font-weight: bold;
  }

  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
`;

export const AmountText = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 1.8;
color: #101415;

  @media screen and (max-width: 325px) {
    font-size: 14px;
  }
`;

export const Text = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
text-align: center;
`;

export const QRCodeContainer = styled.div`
  width: 100%;
  margin-top: 7px;
  display: flex;
  align-items: center;
  justify-content: left;
  border-radius: 8px;
  gap: 8px;
  border-radius: 0px 0px 8px 8px;
  background: #EFEFEF;

  padding: 12px 0;

  @media screen and (max-width: 450px) {
    gap: 0px;
    justify-content: space-between;
  }
`;

export const QRCodeText = styled.div`
  border-radius: 15px;
  background: #C21C05;
  padding-right: 10px;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 5px 9px;
  color: #F7F7F7;
  cursor: pointer;

  @media screen and (max-width: 350px) {
    font-size: 10px;
  }
`;

export const QRCodeImage = styled(AntImage).attrs({
  alt: "QR",
  src: IMG_QR,
  preview: false,
})`
  width: 50px;
  height: 50px;
  max-width: 50px;
  max-height: 50px;
  padding-left: 10px;
  margin: 0 25px 0 0;
`;

export const Wrapper = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const InfoWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 15px;
`;

export const InfoLabel = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #535B5D;
`;

export const InfoText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #101415;

@media screen and (max-width: 375px) {
  font-size: 13px;
}

@media screen and (max-width: 350px) {
  font-size: 12px;
}
`;

export const Box = styled.div`
padding-top: 16px;
display: flex;
flex-direction: column;
gap: 14px;
border-radius: 8px;
border: 1px solid #E6E6E6;
background: #F7F7F7;
`;

export const ImageBox = styled.div`
  display: flex;
  padding-inline: 16px;
  gap: 32px;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 325px) {
    gap: 20px;
  }

  @media screen and (max-width: 320px) {
    padding-inline: 8px;
  }
`;

export const LightText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const LightTextLg = styled(LightText)`
font-size: 14px;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 65px;

  @media screen and (max-width: 350px) {
    width: 55px;
  }
  @media screen and (max-width: 325px) {
    width: 50px;
  }
`;

export const TextWrapper = styled.div`
padding: 0 16px;

@media screen and (max-width: 320px) {
    padding: 0 8px;
  }
`;

export const ButtonSm = styled(Button).attrs({
  type: 'primary',
})`
height: 26px;
padding: 5px 9px;
margin-bottom: -2px;
display: flex;
align-items: center;

span {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5;
  color: #F7F7F7;
}
`;

export const AccountInfo = styled(Space)`
display: flex;
gap: 12px;
padding: 16px 0;
padding-inline: 16px;
align-items: center;
justify-content: flex-start;
background-color: #EFEFEF;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;

.ant-space-item:last-child {
  align-self: flex-end;
}

@media screen and (max-width: 320px) {
    padding-inline: 8px;
}
`;

export const QuestionIcon = styled(QuestionFilled)`
margin-bottom: -2px;
cursor: pointer;
`;

export const DigitBox = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 12px;
  text-align: center;

  .ant-space {
    gap: 4px !important;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 24px;
  position: relative;

  .ant-btn {
    height: 52px;

    :disabled {
      background-color: gray !important;
    }
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInput = styled.input`
  width: 20px !important;
  height: 30px !important;
  border-radius: 8px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "transparent")} !important;
  font-size: 17px !important;
  background-color: #EFEFEF;
  -moz-appearance: textfield;
  appearance: textfield;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const SlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`;

export const EmptyBox = styled.div`
height: calc(100vh - 70px);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 16px;
width: 100%;

.ant-btn-primary {
  height: 52px;
}
`;

export const EmptyText = styled.div`
padding: 0 15%;
font-size: 14px;
font-weight: 500;
text-align: center;

@media screen and (max-width: 360px) {
  padding: 0 12%;
}
`;

export const WarningImage = styled(WarningFilled)`
width: 50px;
height: 50px;
`;

export const ScreenShotBox = styled.div`
  margin: 24px 0 0;
`

export const PalePurpleWrapper = styled.div`
  margin: 12px 0 24px;
  padding: 16px;
  border-radius: 5px;
  border: 1px solid #C21C05;
  background: #F8EEFF !important;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  svg{
    width: 24px;
    height: 24px;
  }

  @media screen and (max-width: 400px) {
    padding: 12px;
  }
`

export const UploadText = styled.p`
  color: #565656;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`

export const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const ColFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

`

export const BlackText = styled.p`
  color: var(--All-black, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  text-align: left;

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }
`

export const GrayText = styled.p`
  color: var(--Second-Text, #9B92BB);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  text-align: left;
`

export const ChangeBtn = styled.div`
  background: #C21C05;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 26px;
  width: 60px;
  font-size: 14px;
`

export const SSWarningText = styled.div`
  color: #23AB41;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`